import Constant from '@/const';
import axios from 'axios';

const postSupplier = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/supplier/`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postSupplier;
